import * as XLSX from "xlsx";
// const documentsService = useService('documents');

export function findMonth(month) {
    const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
    return meses[month - 1]
}
/**
 * Valor em reais, ou '-' quando nao ha valor.
 *
 * A conversao explicita existe porque a API devolve valor monetario como string
 * ("5200.00"), e String.prototype.toLocaleString ignora os argumentos de formato e
 * devolve o proprio texto — era por isso que varias telas mostravam 5200.00 no
 * lugar de R$ 5.200,00. Intl.NumberFormat e o mesmo caminho que o resto do projeto
 * ja usa nos formatadores locais.
 *
 * Zero continua sendo '-': a convencao de cronograma e que zero e nulo significam
 * a mesma coisa, "ainda sem valor".
 */
export function money(value) {
    const number = typeof value === "number" ? value : parseFloat(value);
    if (!Number.isFinite(number) || number === 0) return '-';
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(number);
}
export function formatDate(date) {
    if (!date) return;
    // Split da data para evitar problemas de timezone
    // Se vier do formato YYYY-MM-DD ou YYYY-MM-DDTHH:mm:ss
    const dateStr = date.split('T')[0]; // Pega só a parte da data
    const [year, month, day] = dateStr.split('-').map(Number);

    // Cria a data sem conversão de timezone
    return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
}

export function addOneYear(dateString) {
    if (!dateString) return "";
    const dateStr = dateString.split('T')[0];
    const [year, month, day] = dateStr.split('-').map(Number);
    if (!year || !month || !day) return "";
    const d = new Date(year + 1, month - 1, day);
    if (isNaN(d.getTime())) return "";
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${dd}`;
}

export function isCompleteDate(dateString) {
    if (!dateString || typeof dateString !== 'string') return false;
    const dateStr = dateString.split('T')[0];
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return false;
    const [year, month, day] = dateStr.split('-').map(Number);
    if (year < 1900 || year > 2100) return false;
    const d = new Date(year, month - 1, day);
    return (
        d.getFullYear() === year &&
        d.getMonth() === month - 1 &&
        d.getDate() === day
    );
}

export function isValidCPF(cpf) {
    const digits = cpf.replace(/\D/g, '');
    if (digits.length !== 11) return false;
    if (/^(\d)\1{10}$/.test(digits)) return false;
    const calcDigit = (str, factor) => {
        const sum = str.split('').reduce((acc, d, i) => acc + parseInt(d) * (factor - i), 0);
        const rest = (sum * 10) % 11;
        return rest === 10 ? 0 : rest;
    };
    const d1 = calcDigit(digits.slice(0, 9), 10);
    const d2 = calcDigit(digits.slice(0, 10), 11);
    return parseInt(digits[9]) === d1 && parseInt(digits[10]) === d2;
}

export function isValidCNPJ(cnpj) {
    const digits = cnpj.replace(/\D/g, '');
    if (digits.length !== 14) return false;
    if (/^(\d)\1{13}$/.test(digits)) return false;
    const calcDigit = (str, weights) => {
        const sum = str.split('').reduce((acc, d, i) => acc + parseInt(d) * weights[i], 0);
        const rest = sum % 11;
        return rest < 2 ? 0 : 11 - rest;
    };
    const d1 = calcDigit(digits.slice(0, 12), [5,4,3,2,9,8,7,6,5,4,3,2]);
    const d2 = calcDigit(digits.slice(0, 13), [6,5,4,3,2,9,8,7,6,5,4,3,2]);
    return parseInt(digits[12]) === d1 && parseInt(digits[13]) === d2;
}

export const maskDocument = (v) => {
    if (!v) return
    v = v.replace(/\D/g, "")

    if (v.length <= 11) {
        v = v.replace(/(\d{3})(\d)/, "$1.$2")
        v = v.replace(/(\d{3})(\d)/, "$1.$2")
        v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    } else {
        v = v.replace(/^(\d{2})(\d)/, "$1.$2")
        v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
        v = v.replace(/\.(\d{3})(\d)/, ".$1/$2")
        v = v.replace(/(\d{4})(\d)/, "$1-$2")
    }

    return v
}

// Telefone para exibição. O back grava só dígitos; aceita também valor já mascarado.
// Tamanho fora do padrão (10 ou 11 dígitos) volta como veio.
export const formatPhone = (v) => {
    if (!v) return ""
    const digits = String(v).replace(/\D/g, "")
    if (digits.length === 11) return digits.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3")
    if (digits.length === 10) return digits.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3")
    return String(v)
}

// ===== Invoice Deadline Helpers =====

/**
 * Retorna o N-ésimo dia útil de um mês/ano (ignora sábados e domingos)
 */
export function getNthBusinessDay(year, month, nth) {
    let count = 0;
    let day = 1;
    const lastDay = new Date(year, month, 0).getDate(); // month is 1-based
    while (day <= lastDay) {
        const date = new Date(year, month - 1, day);
        const weekday = date.getDay();
        if (weekday !== 0 && weekday !== 6) {
            count++;
            if (count === nth) return date;
        }
        day++;
    }
    // Fallback: último dia útil do mês
    let lastBizDay = new Date(year, month - 1, lastDay);
    while (lastBizDay.getDay() === 0 || lastBizDay.getDay() === 6) {
        lastBizDay.setDate(lastBizDay.getDate() - 1);
    }
    return lastBizDay;
}

/**
 * Retorna label formatado para o prazo de envio de NF
 * @param {string} type - 'FIXED_DAY' | 'BUSINESS_DAY'
 * @param {number} value
 * @param {string} monthType - 'CURRENT' | 'NEXT' (opcional, default exibe sem contexto de mês)
 */
export function getInvoiceDeadlineLabel(type, value, monthType) {
    if (!type || !value) return "-";
    const monthSuffix = monthType === "NEXT" ? " do mês seguinte" : monthType === "CURRENT" ? " do mês vigente" : " do mês";
    if (type === "FIXED_DAY") return `Dia ${value}${monthSuffix}`;
    if (type === "BUSINESS_DAY") return `${value}º dia útil${monthSuffix}`;
    return "-";
}

/**
 * Retorna label formatado para o prazo de input de valor variável
 * @param {number} value - Dia do mês
 * @param {string} monthType - 'CURRENT' | 'NEXT'
 */
export function getValueInputDeadlineLabel(value, monthType) {
    if (!value) return "-";
    const monthSuffix = monthType === "NEXT" ? "do mês seguinte" : "do mês vigente";
    return `Dia ${value} ${monthSuffix}`;
}

/**
 * Retorna label formatado para a regra de pagamento
 * @param {string} type - 'FIXED_DAY' | 'BUSINESS_DAY' | 'LAST_DAY'
 * @param {number} value
 * @param {string} monthType - 'CURRENT' | 'NEXT'
 */
export function getPaymentRuleLabel(type, value, monthType) {
    if (!type) return "-";
    if (type === "LAST_DAY") return "Último dia do mês";
    if (!value) return "-";
    const monthSuffix = monthType === "NEXT" ? "do mês seguinte" : "do mês vigente";
    if (type === "FIXED_DAY") return `Dia ${value} ${monthSuffix}`;
    if (type === "BUSINESS_DAY") return `${value}º dia útil ${monthSuffix}`;
    return "-";
}

/**
 * Data limite para envio da NF de uma competência, ou null quando o padrão não
 * define prazo. Extraída de isInvoiceDeadlinePassed porque o bloqueio de envio
 * precisa comparar a data em si com o fim da apuração, não só saber se passou.
 *
 * @param {string} type - 'FIXED_DAY' | 'BUSINESS_DAY'
 * @param {number} value - Dia ou N-ésimo dia útil
 * @param {string} monthType - 'CURRENT' | 'NEXT' (default: usa mês atual como referência)
 * @param {number} referenceMonth - Mês de referência 1-12 (default: mês atual)
 * @param {number} referenceYear - Ano de referência (default: ano atual)
 * @returns {Date|null}
 */
export function getInvoiceDeadlineDate(type, value, monthType, referenceMonth, referenceYear) {
    if (!type || !value) return null;
    const now = new Date();
    const refMonth = referenceMonth || (now.getMonth() + 1);
    const refYear = referenceYear || now.getFullYear();
    const isNext = monthType === "NEXT";

    let targetMonth = refMonth;
    let targetYear = refYear;
    if (isNext) {
        if (targetMonth === 12) { targetMonth = 1; targetYear += 1; }
        else { targetMonth += 1; }
    }

    if (type === "FIXED_DAY") {
        const lastDay = new Date(targetYear, targetMonth, 0).getDate();
        const safeDay = Math.min(value, lastDay);
        return new Date(targetYear, targetMonth - 1, safeDay);
    }
    if (type === "BUSINESS_DAY") {
        return getNthBusinessDay(targetYear, targetMonth, value);
    }
    return null;
}

/**
 * Verifica se o prazo para envio de NF já passou, baseado no período de referência.
 * Enviar no próprio dia do prazo ainda passa.
 */
export function isInvoiceDeadlinePassed(type, value, monthType, referenceMonth, referenceYear) {
    const deadlineDate = getInvoiceDeadlineDate(type, value, monthType, referenceMonth, referenceYear);
    if (!deadlineDate) return false;

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return today > deadlineDate;
}

/**
 * Verifica se o prazo para input de valor variável já passou.
 * O prazo do contrato é sempre um dia fixo do mês (não existe dia útil aqui),
 * ancorado na competência informada — mesma regra aplicada pelo back.
 * @param {number} value - Dia do mês
 * @param {string} monthType - 'CURRENT' | 'NEXT'
 * @param {number} referenceMonth - Mês de referência 1-12 (default: mês atual)
 * @param {number} referenceYear - Ano de referência (default: ano atual)
 */
export function isValueInputDeadlinePassed(value, monthType, referenceMonth, referenceYear) {
    if (!value) return false;
    return isInvoiceDeadlinePassed("FIXED_DAY", value, monthType, referenceMonth, referenceYear);
}

/**
 * Verifica se um cronograma já tem valor definido.
 * Zero e null representam o mesmo estado ("ainda sem valor") — mesma regra do back.
 * @param {object} schedule - Cronograma de pagamento
 */
export function scheduleHasValue(schedule) {
    const value = parseFloat(schedule?.expected_value);
    return value > 0;
}

/**
 * Janela mínima, em dias corridos, entre o fim da apuração e o prazo da NF para o
 * bloqueio de envio ser seguro.
 *
 * Com 1 dia o prestador teria uma única data para enviar, e perder esse dia
 * congelaria a competência sem nota. Dois é o mínimo que deixa margem.
 *
 * Dias corridos bastam para os padrões que existem: com fechamento 20 e prazo 25,
 * o pior caso é o dia 21 cair num sábado, e ainda sobram 3 dias úteis. Se um dia
 * existir padrão mais apertado, a conta precisa virar dias úteis.
 */
const MIN_DIAS_JANELA_ENVIO = 2;

/** Diferença em dias corridos entre duas datas de calendário. */
function daysBetween(from, to) {
    return Math.round((to - from) / 86400000);
}

/**
 * Bloqueio de envio enquanto a competência ainda está sendo apurada.
 *
 * Contrato por hora é recalculado a cada aprovação de horas, então no meio da
 * competência o valor esperado está incompleto. E enviar a nota grava o
 * tax_invoice_id, que faz o back parar de recalcular — ou seja, o prestador
 * congelaria o próprio mês num valor parcial, sem poder corrigir, porque o campo
 * de valor da NF é preenchido pelo cronograma.
 *
 * Só bloqueia quando sobra janela depois do fechamento. Nos padrões sem dia de
 * fechamento a apuração vai até o fim do mês e o prazo da NF cai antes disso;
 * bloquear ali deixaria o prestador sem nenhum dia para enviar.
 *
 * @returns {string|null} motivo, ou null se o envio estiver liberado
 */
export function getOpenCompetenceBlockReason(schedule, pattern) {
    if (schedule?.contract?.remuneration_type !== "HOURLY") return null;
    if (!schedule?.period_end) return null;

    const deadlineDate = getInvoiceDeadlineDate(
        pattern?.invoice_deadline_type,
        pattern?.invoice_deadline,
        pattern?.invoice_deadline_month,
        schedule?.reference_month,
        schedule?.reference_year
    );
    if (!deadlineDate) return null;

    const [year, month, day] = schedule.period_end.split("-").map(Number);
    const periodEnd = new Date(year, month - 1, day);

    if (daysBetween(periodEnd, deadlineDate) < MIN_DIAS_JANELA_ENVIO) return null;

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (today > periodEnd) return null;

    const release = new Date(periodEnd);
    release.setDate(release.getDate() + 1);
    const releaseLabel = `${String(release.getDate()).padStart(2, "0")}/${String(release.getMonth() + 1).padStart(2, "0")}`;
    // "Liberado" e nao "voce pode": este e so um dos bloqueios. Dados bancarios e
    // prazo continuam valendo depois dele, e a frase e reusada na tela de detalhes
    // do cronograma, onde soaria como garantia.
    return `Competência em apuração — envio liberado a partir de ${releaseLabel}`;
}

/**
 * Retorna o motivo pelo qual o envio de NF está bloqueado, ou null se estiver liberado.
 * Centraliza os três bloqueios existentes para que a tela nunca mostre o motivo errado.
 *
 * @param {object} schedule - Cronograma de pagamento
 * @param {object} contract - Contrato (fallback quando o cronograma não traz o relacionamento)
 * @param {boolean} noBank - Prestador sem dados bancários cadastrados
 * @returns {string|null}
 */
export function getUploadBlockReason(schedule, contract, noBank) {
    // Competencia que ja saiu do fluxo nao recebe nota, e nenhum outro motivo muda
    // isso — por isso vem antes ate do noBank.
    //
    // Estava so no disabled do botao, e nao aqui: o botao era desabilitado por duas
    // condicoes e explicado por uma, entao a tela mostrava o primeiro outro motivo
    // que este helper encontrasse. Numa competencia paga dava "Prazo encerrado",
    // verdade porem irrelevante.
    if (schedule?.status && schedule.status !== "PENDING") {
        if (schedule.status === "PAID") return "Competência já paga";
        if (schedule.status === "CANCELLED") return "Competência cancelada";
        return "Competência encerrada";
    }

    if (noBank) return "Adicione seus dados bancários para enviar";

    if (!scheduleHasValue(schedule)) {
        const remunerationType =
            schedule?.contract?.remuneration_type || contract?.remuneration_type;
        if (remunerationType === "VARIABLE") {
            return "Aguardando a empresa informar o valor desta competência";
        }
        if (remunerationType === "HOURLY") {
            return "Aguardando aprovação das horas desta competência";
        }
        return "Cronograma ainda sem valor definido";
    }

    const pattern = schedule?.contract?.contract_pattern || contract?.contract_pattern;
    const deadline = pattern?.invoice_deadline;
    if (!deadline) return null;

    const openReason = getOpenCompetenceBlockReason(schedule, pattern);
    if (openReason) return openReason;

    const passed = isInvoiceDeadlinePassed(
        pattern?.invoice_deadline_type,
        deadline,
        pattern?.invoice_deadline_month,
        schedule?.reference_month,
        schedule?.reference_year
    );
    if (!passed) return null;

    const label = getInvoiceDeadlineLabel(
        pattern?.invoice_deadline_type,
        deadline,
        pattern?.invoice_deadline_month
    );
    return `Prazo encerrado (${label})`;
}

// ===== Hour Marking Model Helpers =====

export function getHourMarkingModelLabel(model) {
    const labels = {
        DAILY: "Diário",
        WEEKLY: "Semanal",
        MONTHLY: "Mensal",
    };
    return labels[model] || model || "-";
}

// ===== Hour Tracking Mode Helpers =====

export function getHourTrackingModeLabel(mode) {
    const labels = {
        HOURS_ONLY: "Apenas horas trabalhadas",
        HOURS_AND_ABSENCES: "Horas e dias ausentes",
        ABSENCES_ONLY: "Apenas dias ausentes",
        FIXED_WITH_HOUR_ADJUSTMENT: "Valor fixo com ajuste por horas",
    };
    return labels[mode] || mode || "-";
}

  export const convertExcelToJson = async (excelUrl) => {

    try {
      // Convert the Excel buffer to a workbook
      const workbook = XLSX.read(excelUrl, { type: "array" });
      
      // Get the first sheet
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      
      // Convert the sheet data to JSON
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      
      // Map the array to an array of objects
      const resultArray = jsonData.map((row) => {
        const obj = {};
        for (let i = 0; i < jsonData[0].length; i++) {
          obj[jsonData[0][i]] = row[i];
        }
        return obj;
      });
  
      return resultArray.slice(1);
    } catch (error) {
      console.error("Error converting Excel to JSON:", error);
      throw error;
    }
  };